<template>
    <div class="modal" id="searchAndSelectCommodityModal" role="dialog" tabindex="-1">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Add Commodity</h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="card-body">
                        <b-col class="my-1" lg="6">
                            <b-form-group
                                    class="mb-4"
                                    label="Filter"
                                    label-align-sm="left"
                                    label-cols-sm="1"
                                    label-for="filter-input"
                                    label-size="sm">
                                <b-input-group size="sm">
                                    <b-form-input class="ml-2"
                                                  id="filter-input"
                                                  placeholder="Search by Name, Variety & Code"
                                                  type="search"
                                                  v-model="filter">
                                    </b-form-input>
                                    <b-input-group-append>
                                        <b-button @click="reset()">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-table :busy="busy" :current-page="currentPage" :fields="fields" :filter="filter"
                                 :filter-included-fields="filterOn"
                                 :items="commodities"
                                 :per-page="perPage"
                                 :sort-by="sortBy"
                                 :sort-desc="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"
                                 bordered
                                 class="table-condensed background-color-important" responsive small v-if="totalRows>0">
                            <template #cell(id)="data">
                                <div class="form-check">
                                    <input class="form-check-input"
                                           @change="changeSelect($event)"
                                           type="checkbox"
                                           v-bind:id="'_id'+data.value"
                                           v-bind:value="data.value"
                                           v-model="selectedCommodities">
                                    <label class="form-check-label" v-bind:for="'_id'+data.value"></label>
                                </div>
                            </template>
                            <template #cell(rate)="data">
                                <span v-if="data.value.amount">{{data.value | money}}</span>
                                <span v-else>NA</span>
                            </template>
                            <template #cell(commodity_props)="data">
                                <ul>
                                    <li v-bind:key="index" v-for="(cp, index) in data.value">
                                        {{cp.value}}
                                    </li>
                                </ul>
                            </template>
                        </b-table>
                        <template v-else>
                            <h4 class="card-title text-muted text-center m-t-30">No records found.</h4>
                            <h5 class="card-title text-muted text-center m-b-30">Change search criteria and try
                                again</h5>
                        </template>
                    </div>
                    <div class="card-footer" v-if="totalRows>5">
                        <div class="row">
                            <div class="col">
                                <per-page :total="totalRows" v-model="perPage"/>
                            </div>
                            <div class="col-auto" v-if="totalRows>perPage">
                                <b-pagination :per-page="perPage" :total-rows="totalRows" v-model="currentPage"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button @click="setCommodities" class="btn btn-outline-success" data-dismiss="modal" type="submit">Add
                    </button>
                    <button class="btn btn-outline-secondary" data-dismiss="modal" type="reset">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Paginate from 'vuejs-paginate';
    import PerPage from "@/components/protected/common/PerPage.vue";

    export default {
        name: "SearchSelectCommodity",
        props: {
            checkedCommodityIds: Array,
            singleSelect: Boolean,
            preCommodities: Array
        },
        watch: {
            checkedCommodityIds: function (nv, ov) {
                this.selectedCommodities = nv;
            },
            preCommodities: function (nv, ov) {
                if(nv && nv.length>0) {
                    this.commodities = nv;
                    this.totalRows = nv.length;
                }else {
                    this.getCommodities()
                }
            }
        },
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Paginate, PerPage},
        data() {
            return {
                pageCount: 1,
                total: 0,
                member: {
                    id: null,
                    biz_name: null
                },
                commodities: [],
                selectedCommodities: [],
                fields: [
                    {
                        key: 'id',
                        label: '',
                    },
                    {
                        key: 'name',
                        sortable: true,
                    },
                    {
                        key: 'code',
                        sortable: true,
                    },
                    {
                        key: 'variety',
                        sortable: true,
                    },
                    {
                        key: 'rate',
                        sortable: true,
                    },
                    {
                        key: 'commodity_props',
                        label: 'Property'
                    }
                ],
                busy: false,
                currentPage: 1,
                perPage: 5,
                totalRows: 0,
                sortBy: 'name',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                filterOn: ['name', 'variety', 'code']
            }
        },
        mounted() {
            this.selectedCommodities = this.checkedCommodityIds;
            if(typeof this.preCommodities == 'undefined' || this.preCommodities.length === 0) {
                this.getCommodities();
            }else {
                this.commodities = this.preCommodities;
                this.totalRows = this.preCommodities.length;
            }
        },
        methods: {
            getCommodities() {
                this.$http
                    .get(`/marketplaces/${this.currentOrg.marketplace_id}/commodities`, {
                        params: {
                            page: 1,
                            perPage: 1000

                        }
                    })
                    .then(reply => {
                        this.totalRows = reply.data.total;
                        this.commodities = reply.data.commodities;
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            pageHandler(pageNum) {
                this.getCommodities();
            },
            setPageCount() {
                this.pageCount = this.total <= this.perPage ? 1 : Math.ceil(this.total / this.perPage);
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            reset() {
                this.filter = null;
                this.getCommodities()
            },
            setCommodities() {
                let self = this;
                this.selectedCommodities = this.commodities.filter(c=> self.selectedCommodities.includes(c.id));
                this.$emit('commodity-select', this.selectedCommodities);
            },
            changeSelect(e){
                if(this.singleSelect && e.target.checked) {
                    this.selectedCommodities = [Number(e.target.value)]
                }
            }
        }
    }
</script>

<style scoped>
    .table-condensed {
        font-size: 11px;
    }

    .background-color-important {
        background-color: white !important;
    }
</style>
